import React, { useEffect, useState } from 'react'
import { IModal } from './AssignmentMast'
import { Toolbar } from 'primereact/toolbar'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { emptyForm, IAssignmentForm } from './Form'
import { Fetch } from '../../shared/Fetch'
import { EmptyAssignmentMastFilter, Filter, IAssignmentMastFilter } from './Filter'
import { Accordion, AccordionTab } from 'primereact/accordion'


interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
}

export default function Table(props: Iprops) {
    const [tableData, setTableData] = useState<IAssignmentForm[]>([]);
    const [filters, setFilters] = useState<IAssignmentMastFilter>(EmptyAssignmentMastFilter);
    const [loading, setLoading] = useState<boolean>(false);



    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const openNew = () => {
        props.setModal({ open: true, singleData: emptyForm });
    };
    const openEdit = (rowData: IAssignmentForm) => {
        props.setModal({ open: true, singleData: rowData });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Assignment</h5>
        </div>
    );

    const loadTableData = async () => {
        const response = await Fetch('Assignment_Mast', "GET", null, `filter=${JSON.stringify(filters)}`, props.toast);
        if (response) {
            const data = await response.json();
            setTableData(data);
        }
    }

    const ActiveStatus = (rowData: IAssignmentForm) => {
        return (
            <span style={{ color: rowData.status === true ? 'green' : 'red' }} className="cursor-pointer" onClick={() => { toggleVal(rowData.id) }}>{rowData.status ? "Yes" : "No"}</span>
        );

    };


    const toggleVal = async (Id?: number) => {
        const response = await Fetch("Assignment_Mast/toggleStatus", "PUT", null, `Id=${Id}`, props.toast);
        if (response) {
            let message: string = " Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload, filters])

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IAssignmentMastFilter) => setFilters(filters)} loading={loading} reload={props.reload} setReload={props.setReload} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field='assignment_Name' header="Assignment Name" />
                <Column field="assignment_Descriptions" header="Assignment Description" />
                <Column field="department" header="Department" />
                <Column field="status" header="Active" body={ActiveStatus} />
                <Column field="" header="Action" body={(rowData: IAssignmentForm) => <Button icon="pi pi-pencil" className="p-button-warning mr-2" onClick={() => openEdit(rowData)} />} />
            </DataTable>
        </>
    )
}
